<footer class="py-5 mt-6" style="background: #141311; color: #a49e93; border-top: 1px solid #2b2823;">
  <div class="container">
    <div class="row g-4 justify-content-between">
      <div class="col-lg-4 mb-3">
        <div class="d-flex align-items-center mb-3">
          <img src="/static/assets/img/logoartiquary.png" alt="Antiqry Logo" height="34" class="me-2" style="filter: brightness(1.2);" />
          <span class="brand-font fs-3 text-white fw-bold">Antiqry</span>
        </div>
        <p class="small text-muted mb-3" style="line-height: 1.7;">
          A living provenance registry and fine antiques marketplace dedicated to continuous historical tracking, documented custody, and enduring legacy across collectors and generations.
        </p>
        <div class="badge-provenance" style="background: rgba(191,161,95,0.15); color: #d4b46a; border-color: rgba(191,161,95,0.3);">
          <span class="material-symbols-outlined" style="font-size: 15px;">verified</span>
          {{ 'STATUS.VERIFIED_LINEAGE' | translate }}
        </div>
      </div>

      <div class="col-6 col-lg-2">
        <h6 class="text-white brand-font mb-3">{{ 'NAV.COLLECTIONS' | translate }} & {{ 'NAV.MARKETPLACE' | translate }}</h6>
        <ul class="list-unstyled small">
          <li class="mb-2"><a class="text-decoration-none text-muted" routerLink="/items/search" [queryParams]="{selling: 'false'}">{{ 'NAV.COLLECTIONS' | translate }}</a></li>
          <li class="mb-2"><a class="text-decoration-none text-muted" routerLink="/items/search" [queryParams]="{selling: 'true'}">{{ 'NAV.MARKETPLACE' | translate }}</a></li>
          <li class="mb-2"><a class="text-decoration-none text-muted" routerLink="/items/list">{{ 'NAV.CATALOG_OBJECT' | translate }}</a></li>
          <li class="mb-2"><a class="text-decoration-none text-muted" routerLink="/my-items">{{ 'NAV.MY_COLLECTION' | translate }}</a></li>
        </ul>
      </div>

      <div class="col-6 col-lg-3">
        <h6 class="text-white brand-font mb-3">The Provenance Model</h6>
        <p class="small text-muted mb-2">
          Unlike traditional antique shops, an object's history never closes upon sale. The chain of custody, historical notes, and restoration logs transfer seamlessly to the new collector.
        </p>
      </div>

      <div class="col-lg-3">
        <h6 class="text-white brand-font mb-3">Collector Support</h6>
        <p class="small text-muted mb-2">
          Support, appraisals, and inquiries:
        </p>
        <p class="small text-white fw-bold mb-1">concierge&#64;antiqry.com</p>
        <p class="small text-muted">Google Cloud Platform &bull; Cloud Firestore</p>
      </div>
    </div>

    <div class="pt-4 mt-4 border-top border-dark d-flex flex-wrap justify-content-between align-items-center small text-muted gap-2">
      <div>
        &copy; 2026 Antiqry. All rights reserved. Where things turn legacy.
      </div>
      <div class="d-flex flex-wrap align-items-center gap-3 mt-2 mt-md-0">
        <!-- Discreet Footer Language Switcher -->
        <div class="d-flex align-items-center gap-1">
          <span class="material-symbols-outlined text-muted" style="font-size: 15px;">language</span>
          <select class="form-select form-select-sm bg-dark text-muted border-secondary py-0 px-2 shadow-none" style="font-size: 12px; width: auto; height: 26px;"
                  [value]="i18nService.currentLang$ | async" 
                  (change)="i18nService.setLanguage($any($event.target).value)">
            <option *ngFor="let lang of i18nService.languages" [value]="lang.code">
              {{ lang.flag }} {{ lang.nativeName }}
            </option>
          </select>
        </div>

        <!-- Discreet Footer Currency Switcher -->
        <div class="d-flex align-items-center gap-1">
          <span class="material-symbols-outlined text-muted" style="font-size: 15px;">payments</span>
          <select class="form-select form-select-sm bg-dark text-muted border-secondary py-0 px-2 shadow-none" style="font-size: 12px; width: auto; height: 26px;"
                  [value]="(currencyService.currentCurrency$ | async)?.code" 
                  (change)="currencyService.setCurrency($any($event.target).value)">
            <option *ngFor="let cur of currencyService.currencies" [value]="cur.code">
              {{ cur.flag }} {{ cur.code }} ({{ cur.symbol }})
            </option>
          </select>
        </div>

        <span class="badge bg-dark text-muted">App Engine europe-west2</span>
        <span class="badge bg-dark text-muted">Angular 20</span>
      </div>
    </div>
  </div>
</footer>